export default function (http) {
    return {
        getInfo (data){
            return http.json({
                url: '/card/setting/getOne',
                data
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/shujuguanli.js